import { NgModule } from '@angular/core';
import { PrComparaisonComponent } from './pr-comparaison.component';
import { PrIconModule } from '../pr-icon/pr-icon.module';
import { PrValueModule } from '../pr-value/pr-value.module';
import { CommonModule } from '@angular/common';
import { PrSwiperModule } from '../pr-swiper/pr-swiper.module';
import { PrLabelModule } from '../pr-label/pr-label.module';

@NgModule({
  declarations: [PrComparaisonComponent],
  imports: [
    CommonModule,
    PrIconModule,
    PrValueModule,
    PrLabelModule,
    PrSwiperModule,
  ],
  exports: [PrComparaisonComponent],
})
export class PrComparaisonModule {}
